module.exports = __webpack_public_path__ + "img/28.21122156.jpg";